import React from "react";
import axios from "../../../containers/api";
import { Link } from "react-router-dom";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { Table } from "../../../components/table/Table";
import Config from "../../../constants/config";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Row,
  Colxxو,
} from "reactstrap";
import {
  getkalas,
  showCatchError,
  convertDate,
  toCurrency,
  toEnglishNumbers,
} from "../../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

class Cargos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      fromDate: utils("fa").getToday(),
      toDate: utils("fa").getToday(),
      Cargos: [],
      customers: [],
      kalas: [],
      senders: [],
      receivers: [],
      selectedkalas: [],
      CargosSearchResult: [],
      CargoId: null,
      TransportationCompanyList: [],
      TransportationCompany: null,
      selectedCargoStatus: { value: 2, text: "همه" },
      CargoStatus: [
        { value: 0, text: "فعال" },
        { value: 1, text: "غیرفعال" },
        { value: 2, text: "همه" },
      ],
      FinishCargoModal: false,
      IsLoadHall: false,
      FinishDesc: "",
      PriorityList: [],
      PriorityModal: false,
      priorityMsg: "",
      ReserveList: [],
      ReserveModal: false,
      ReserveMsg: "",
      CityList: [],
      City: null,
    };
  }

  // دریافت شهرهای سالن
  loadLoadHallCity = () => {
    this.props.showSpinner();
    axios
      .get("api/v1/load-hall-cities/cities")
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ CityList: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  componentDidMount() {
    this.SearchCargo();
    this.loadLoadHallCity();

    if (this.state.kalas.length === 0) {
      getkalas().then((res) => this.setState({ kalas: res.data }));
    }

    const { role } = this.props.memberType;
    if (
      [
        "AdminSupport",
        "Admin",
        "Organization",
        "DriversAssociation",
        "AssociationTransportCompanies",
      ].includes(role)
    ) {
      //this.GetAllTransportationCompany();
      //this.GetAllCustomer();
    } else {
      // this.GetCustomerByTransportationCompanyId();
    }

    window.scrollTo(0, 0);
  }

  // دریافت مشتریان
  // GetCustomerByTransportationCompanyId = () => {
  //   axios.get('/api/v1/customers/GetCustomerByTransportationCompanyId')
  //     .then(res => this.setState({ customers: res.data.data }))
  //     .catch(err => this.props.showAlert(showCatchError(err), "error"));
  // };

  // GetAllCustomer = () => {
  //   axios.get('/api/v1/customers/GetAllCustomer')
  //     .then(res => this.setState({ customers: res.data.data }))
  //     .catch(err => this.props.showAlert(showCatchError(err), "error"));
  // };

  // دریافت شرکت‌های حمل
  GetAllTransportationCompany = () => {
    const { role } = this.props.memberType;
    const api = [
      "Organization",
      "DriversAssociation",
      "AssociationTransportCompanies",
    ].includes(role)
      ? "transportation-company-users/GetByUserId"
      : "transportation-companies/GetAll";

    axios
      .get(`/api/v1/${api}`)
      .then((res) =>
        this.setState({ TransportationCompanyList: res.data.data }),
      )
      .catch((err) => this.props.showAlert(showCatchError(err), "error"));
  };

  // جستجوی بار
  SearchCargo = () => {
    const {
      fromDate,
      toDate,
      receivers,
      senders,
      selectedkalas,
      selectedCargoStatus,
      City,
      TransportationCompany,
    } = this.state;
    const { role } = this.props.memberType;

    const searchModel = {
      FromDate: convertDate(fromDate),
      ToDate: convertDate(toDate),
      ReceiverCustomerId: receivers.map((r) => r.id),
      SenderCustomerId: senders.map((s) => s.id),
      KalaId: selectedkalas.map((k) => k.id),
      CargoStatus: selectedCargoStatus.value,
      TransportationCompanyId: null,
      LoadHallCityId: City?.cityId || null,
    };

    if (
      [
        "AdminSupport",
        "Admin",
        "Organization",
        "DriversAssociation",
        "AssociationTransportCompanies",
      ].includes(role)
    ) {
      searchModel.TransportationCompanyId =
        TransportationCompany?.transportationCompanyId || null;
    }

    this.props.showSpinner();
    axios
      .post("/api/v1/cargos/SearchCargo", searchModel)
      .then((res) => {
        this.props.hideSpinner();
        const data = res.data.data || [];
        this.setState({ CargosSearchResult: data });

        this.props.showAlert(
          data.length === 0 ? "موردی یافت نشد" : `${data.length} مورد یافت شد`,
          data.length === 0 ? "warning" : "success",
        );
      })
      .catch((err) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(err), "error");
      });
  };

  // پاک کردن فیلترها
  clearSearch = () => {
    this.setState({
      receivers: [],
      senders: [],
      selectedkalas: [],
      selectedCargoStatus: { value: 2, text: "همه" },
      fromDate: utils("fa").getToday(),
      toDate: utils("fa").getToday(),
      City: null,
      TransportationCompany: null,
    });
  };

  // تغییر وضعیت
  ReturnCargo = (CargoId) => {
    this.props.closeSweetAlert();
    this.props.showSpinner();
    axios
      .post("/api/v1/cargos/ReturnCargo", {
        Id: CargoId,
        Desc: "تغییر وضعیت به در حال ارسال",
      })
      .then((res) => {
        this.props.hideSpinner();
        this.props.showAlert(res.data.message, "success");
        this.SearchCargo();
      })
      .catch((err) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(err), "error");
      });
  };

  // اتمام بار
  FinishCargo = () => {
    this.props.closeSweetAlert();
    const { CargoId, FinishDesc, IsCancelPriority } = this.state;
    if (!FinishDesc?.trim())
      return this.props.showAlert(
        "وارد کردن علت اتمام بار الزامی میباشد!",
        "error",
      );

    this.props.showSpinner();
    axios
      .post("/api/v1/cargos/FinishCargo", {
        Id: CargoId,
        IsCancelPriority:
          this.props.memberType.role === "Admin" ? IsCancelPriority : null,
        Desc: toEnglishNumbers(FinishDesc),
      })
      .then((res) => {
        this.props.hideSpinner();
        this.props.showAlert(res.data.message, "success");
        this.setState({ FinishCargoModal: false });
        this.SearchCargo();
      })
      .catch((err) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(err), "error");
      });
  };

  // دریافت اولویت‌ها
  GetByDriverPriority = (CargoId) => {
    this.props.showSpinner();
    axios
      .get(`/api/v1/driver-priorities/GetByCargoId?CargoId=${CargoId}`)
      .then((res) => {
        this.props.hideSpinner();
        const data = res.data.data || [];
        this.setState({
          PriorityList: data,
          priorityMsg: data.length ? "" : "درخواستی ثبت نشده است",
        });
      })
      .catch((err) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(err), "error");
      });
  };

  // دریافت مجوزها
  GetByDriverReserve = (CargoId) => {
    this.props.showSpinner();
    axios
      .get(`/api/v1/driver-reservations/GetReserveByCargoId?CargoId=${CargoId}`)
      .then((res) => {
        this.props.hideSpinner();
        const data = res.data.data || [];
        this.setState({
          ReserveList: data,
          ReserveMsg: data.length ? "" : "مجوزی صادر نشده است",
        });
      })
      .catch((err) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(err), "error");
      });
  };

  // هندلر تغییر
  selectHandleChange = (e, value, name) => {
    this.setState({ [name]: value });
  };

  closeModal = (name) => this.setState({ [name]: false });

  render() {
    const { memberType } = this.props;
    const isAdmin = [
      "AdminSupport",
      "Admin",
      "Organization",
      "DriversAssociation",
      "AssociationTransportCompanies",
    ].includes(memberType.role);

    return (
      <>
        {/* هدر */}
        <Row>
          <Colxx xxs="12">
            <h3 className="mb-4">لیست بارهای اعلام شده</h3>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* فرم جستجو */}
        <Row>
          <Colxx xxs="12">
            <Card className="shadow-sm">
              <CardBody>
                <CardTitle className="text-primary">جستجو</CardTitle>
                <div className="p-4 border rounded bg-light">
                  {/* ردیف اول */}
                  <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap gap-3 mb-3">
                    <FormGroup className="flex-fill min-w-200">
                      <Label>از تاریخ</Label>
                      <DatePicker
                        value={this.state.fromDate}
                        onChange={(d) => this.setState({ fromDate: d })}
                        inputPlaceholder="انتخاب تاریخ"
                        shouldHighlightWeekends
                        inputClassName="form-control"
                        locale="fa"
                        colorPrimary={Config.color}
                        calendarPopperPosition="bottom"
                      />
                    </FormGroup>

                    <FormGroup className="flex-fill min-w-200">
                      <Label>تا تاریخ</Label>
                      <DatePicker
                        value={this.state.toDate}
                        onChange={(d) => this.setState({ toDate: d })}
                        inputPlaceholder="انتخاب تاریخ"
                        shouldHighlightWeekends
                        inputClassName="form-control"
                        locale="fa"
                        colorPrimary={Config.color}
                        calendarPopperPosition="bottom"
                      />
                    </FormGroup>

                    <FormGroup className="flex-fill min-w-200">
                      <Label>نوع محموله</Label>
                      <Autocomplete
                        multiple
                        options={this.state.kalas}
                        value={this.state.selectedkalas}
                        getOptionLabel={(opt) => opt.kalaDesc}
                        onChange={(e, v) =>
                          this.selectHandleChange(e, v, "selectedkalas")
                        }
                        renderInput={(params) => (
                          <TextField {...params} variant="standard" />
                        )}
                      />
                    </FormGroup>
                  </div>

                  {/* ردیف دوم */}
                  <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap gap-3 mb-3">
                    <FormGroup className="flex-fill min-w-200">
                      <Label>وضعیت</Label>
                      <Autocomplete
                        disableClearable
                        options={this.state.CargoStatus}
                        value={this.state.selectedCargoStatus}
                        getOptionLabel={(opt) => opt.text}
                        onChange={(e, v) =>
                          this.selectHandleChange(e, v, "selectedCargoStatus")
                        }
                        renderInput={(params) => (
                          <TextField {...params} variant="standard" />
                        )}
                      />
                    </FormGroup>
                  </div>

                  {/* ردیف سوم */}
                  <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap gap-3 mb-4">
                    {isAdmin && (
                      <FormGroup className="flex-fill min-w-200">
                        <Label>شرکت حمل</Label>
                        <Autocomplete
                          options={this.state.TransportationCompanyList}
                          value={this.state.TransportationCompany}
                          getOptionLabel={(opt) =>
                            opt.transportationCompanyName
                          }
                          onChange={(e, v) =>
                            this.selectHandleChange(
                              e,
                              v,
                              "TransportationCompany",
                            )
                          }
                          renderInput={(params) => (
                            <TextField {...params} variant="standard" />
                          )}
                        />
                      </FormGroup>
                    )}
                    {isAdmin && (
                      <FormGroup className="flex-fill min-w-200">
                        <Label>شهر</Label>
                        <Autocomplete
                          options={this.state.CityList}
                          value={this.state.City}
                          getOptionLabel={(opt) => opt.cityName}
                          onChange={(e, v) =>
                            this.selectHandleChange(e, v, "City")
                          }
                          renderInput={(params) => (
                            <TextField {...params} variant="standard" />
                          )}
                        />
                      </FormGroup>
                    )}
                    <div className="flex-fill min-w-200" />
                  </div>

                  {/* دکمه‌ها */}
                  <div className="d-flex justify-content-center gap-3">
                    <Button
                      color="primary"
                      size="lg"
                      onClick={this.SearchCargo}
                    >
                      جستجو
                    </Button>
                    <Button
                      color="secondary"
                      size="lg"
                      onClick={this.clearSearch}
                    >
                      پاک کردن
                    </Button>
                  </div>
                </div>

                {/* جدول اصلی */}
                <div className="mt-4">
                  <Table
                    tableHeaders={[
                      "شناسه",
                      "وضعیت بار",
                      "صاحب کالا",
                      "مبدا",
                      "مقصد",
                      "کرایه",
                      "وزن",
                      "نوع محموله",
                      "نوع ماشین",
                      "مجوزها",
                      "اتمام بار",
                      "تعداد",
                      "ویرایش",
                      "تاریخ",
                      "ساعت",
                      "توضیحات",
                    ]}
                    tableRow={this.state.CargosSearchResult}
                    tableData={[
                      (c) => c.id,
                      (c) => {
                        const status = {
                          0: { color: "success", text: "در حال ارسال" },
                          1: { color: "warning", text: "اتمام بار" },
                          "-1": { color: "danger", text: "در انتظار بررسی" },
                          2: { color: "primary", text: "بارگذاری حواله" },
                          3: { color: "primary", text: "بارگذاری بارنامه" },
                        }[c.cargoStatus] || {
                          color: "secondary",
                          text: "نامشخص",
                        };
                        return (
                          <Badge color={`outline-${status.color}`} pill>
                            {status.text}
                          </Badge>
                        );
                      },
                      (c) => c.transportationCompanyName,
                      (c) => c.cargoSource,
                      (c) => c.cargoDestination,
                      (c) => (c.cargoRent ? toCurrency(c.cargoRent) : "-"),
                      (c) => c.kalaWeight,
                      (c) => c.kalaDesc,
                      (c) => c.loaderTypeNames,
                      (c) => (
                        <Button
                          outline
                          color="success"
                          size="sm"
                          onClick={() =>
                            this.setState(
                              { CargoId: c.id, ReserveModal: true },
                              () => this.GetByDriverReserve(c.id),
                            )
                          }
                        >
                          مجوزها
                        </Button>
                      ),
                      (c) =>
                        c.cargoStatus != 1 ? (
                          <Button
                            outline
                            color="success"
                            size="sm"
                            onClick={() =>
                              this.setState({
                                FinishCargoModal: true,
                                FinishDesc: "",
                                CargoId: c.id,
                                IsLoadHall: c.isLoadHall,
                              })
                            }
                          >
                            اتمام بار
                          </Button>
                        ) : (
                          `${c.finishDate}-${c.finishTime}`
                        ),

                      (c) => c.freighterNumber,

                      (c) =>
                        !isAdmin && c.role !== "ProductOwnerAdmin" ? (
                          <Link to={`/EditCargo/${c.id}`}>
                            <Button outline color="secondary" size="sm">
                              ویرایش
                            </Button>
                          </Link>
                        ) : (
                          ""
                        ),
                      (c) => c.cargoDate,
                      (c) => c.cargoTime,
                      (c) => c.description,
                    ]}
                  />
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        {/* مدال اتمام بار */}
        <Modal
          isOpen={this.state.FinishCargoModal}
          toggle={() => this.closeModal("FinishCargoModal")}
          size="lg"
        >
          <ModalHeader toggle={() => this.closeModal("FinishCargoModal")}>
            اتمام بار
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>علت اتمام بار</Label>
              <Input
                value={this.state.FinishDesc}
                onChange={(e) => this.setState({ FinishDesc: e.target.value })}
              />
            </FormGroup>
            {memberType.role === "Admin" && this.state.IsLoadHall && (
              <FormGroup>
                <CustomInput
                  type="checkbox"
                  id="IsCancelPriority"
                  label="لغو اولویت‌های فعال"
                  checked={this.state.IsCancelPriority}
                  onChange={() =>
                    this.setState({
                      IsCancelPriority: !this.state.IsCancelPriority,
                    })
                  }
                />
              </FormGroup>
            )}
            <div className="text-center mt-3">
              <Button
                color="success"
                size="lg"
                onClick={() =>
                  this.props.showSweetAlert(
                    "اتمام بار انجام شود؟",
                    "",
                    "success",
                    this.FinishCargo,
                  )
                }
              >
                تایید
              </Button>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => this.closeModal("FinishCargoModal")}
            >
              انصراف
            </Button>
          </ModalFooter>
        </Modal>

        {/* مدال لیست درخواست */}
        <Modal
          isOpen={this.state.PriorityModal}
          toggle={() => this.closeModal("PriorityModal")}
          size="xlg"
        >
          <ModalHeader toggle={() => this.closeModal("PriorityModal")}>
            <h4>لیست درخواست‌های مجوز</h4>
            <small>برای مجوزهای قطعی، دکمه "مجوزها" را بزنید</small>
          </ModalHeader>
          <ModalBody>
            {this.state.priorityMsg ? (
              <p className="text-center text-muted">{this.state.priorityMsg}</p>
            ) : (
              <Table
                tableHeaders={[
                  "تاریخ نوبت",
                  "ساعت نوبت",
                  "شناسه",
                  "اولویت",
                  "تاریخ درخواست",
                  "ساعت درخواست",
                  "راننده",
                  "وضعیت",
                ]}
                tableRow={this.state.PriorityList}
                tableData={[
                  (x) => x.turnDate,
                  (x) => x.turnTime,
                  (x) => x.id,
                  (x) => x.priority,
                  (x) => x.date,
                  (x) => x.time,
                  (x) => x.driverName,
                  (x) => {
                    const status =
                      {
                        0: "danger",
                        1: "secondary",
                        2: "info",
                        3: "danger",
                        4: "danger",
                        5: "danger",
                      }[x.status] || "secondary";
                    const text =
                      [
                        "حذف",
                        "در انتظار",
                        "تایید",
                        "لغو پیش‌نوبت",
                        "لغو توسط راننده",
                        "لغو توسط پشتیبانی",
                      ][x.status] || "نامشخص";
                    return (
                      <Badge color={`outline-${status}`} pill>
                        {text}
                      </Badge>
                    );
                  },
                ]}
              />
            )}
          </ModalBody>
        </Modal>

        {/* مدال لیست مجوز */}
        <Modal
          isOpen={this.state.ReserveModal}
          toggle={() => this.closeModal("ReserveModal")}
          size="xlg"
        >
          <ModalHeader toggle={() => this.closeModal("ReserveModal")}>
            <h4>لیست مجوزهای صادر شده</h4>
          </ModalHeader>
          <ModalBody>
            <Table
              tableHeaders={[
                "شناسه",
                "تاریخ",
                "زمان",
                "راننده",
                "کد ملی",
                "موبایل",
                "هوشمند راننده",
                "هوشمند ماشین",
                "پلاک",
                "وضعیت",
              ]}
              tableRow={this.state.ReserveList}
              tableData={[
                (r) => r.id,
                (r) => r.driverReserveDate,
                (r) => r.driverReserveTime,
                (r) => `${r.driverName} ${r.driverFamily}`,
                (r) => r.driverNationalId,
                (r) => r.driverMobile,
                (r) => r.driverCardNumber,
                (r) => r.freighterCardNumber,
                (r) => r.plaque,
                (r) => {
                  const status =
                    {
                      0: "danger",
                      1: "success",
                      2: "warning",
                      3: "warning",
                      4: "warning",
                      5: "warning",
                      6: "warning",
                    }[r.status] || "secondary";
                  const text =
                    [
                      "باطل",
                      "قطعی",
                      "چاپ",
                      "حواله",
                      "بارنامه",
                      "تحویل",
                      "اتمام",
                    ][r.status] || "نامشخص";
                  return (
                    <Badge color={`outline-${status}`} pill>
                      {text}
                    </Badge>
                  );
                },
              ]}
            />
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default Cargos;
